<ng-template #benchmarkTooltip>
  <h3 class="title">{{ title }}</h3>
  <div role="tooltip" class="benchmark-tooltip-body">
    <div class="rate">{{ efficiency }}%</div>
    <div class="line bg-danger"></div>
    <div class="line line__lowest-limit"></div>
    <div class="text-limits text-limits__left">100</div>
    <div class="text-limits text-limits__center">50</div>
    <div class="text-limits text-limits__right">0</div>
  </div>
</ng-template>

<span
  [ngbPopover]="benchmarkTooltip"
  placement="right"
  triggers="mouseenter:mouseleave"
  popoverClass="benchmark-stars-component-popover-container"
  container="body"
>
  <i
    *ngFor="let star of scores; index as starIndex"
    [ngClass]="{
      'brenchmark-star-icon': true,
      'fa fa-star': true,
      filled: score > starIndex
    }"
  ></i>
</span>
